import Button, { ButtonProps } from '@mui/material/Button'
import './ButtonElement.scss'
import { useTheme } from '@mui/material'

interface ButtonElementButtonProps extends ButtonProps {
    customType?: ColorButton
}

export type ColorButton = "Primary" | "Secondary" | "Transparent"

const ButtonElement = (props: ButtonElementButtonProps) => {
    const theme = useTheme()
    // const over = {...props, cx: {{}}}
    let color = theme.palette.primary.main
    if (props?.customType === 'Secondary') {
        color = theme.palette.secondary.main
    } else if (props?.customType === 'Transparent') {
        color = theme.palette.transparent
    }
    const combineClassName = `${props?.className ?? ''} btn-custom-element `
    const combineStyle = { backgroundColor: color, ...props?.sx }
    return (
        <Button  {...props} sx={combineStyle} className={combineClassName} >
            {props.children}
        </Button>
    )
}

export default ButtonElement
